module.exports = __webpack_public_path__ + "fontawesome-webfont.7c87870ab40d63cfb887.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.ttf?v=4.4.0
// module id = ../../../../../src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.ttf?v=4.4.0
// module chunks = styles